"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessagesEnumIE = {
    subscribeDone: {
        fr: 'Vous avez déjà paramétré la réception des documents {{ senderName}} sur Digiposte. Il suffit de vous connecter directement avec votre identifiant e-mail via cette URL :  {{signupLegacy}}/identification-plus',
        en: 'You have already configured the reception of {{senderName}} documents on Digiposte. All you have to do is connect directly with your e-mail identifier via this URL: {{signupLegacy}}/identification-plus',
    },
    authentification401: {
        fr: 'Les identifiants renseignés sont incorrects et ne permettent pas de vous identifier. Merci de vérifier votre saisie ou de contacter votre interlocuteur chez {{ senderName}}',
        en: 'The login details entered are incorrect and you cannot log in. Please check login details or get in touch with your contact person at {{senderName}}.',
    },
    authentification429: {
        fr: 'Vous avez effectué trop de tentatives infructeuses. Pour une raison de sécurité, nous avons bloqué temporairement cette étape. Merci de réessayer plus tard.',
        en: 'You have made too many unsuccessful attempts. For security reasons, we have temporarily blocked this step. Please try again later.',
    },
    authentification410: {
        fr: 'Les identifiants renseignés sont expirés. Merci de saisir vos identifiants les plus récents ou de contacter votre interlocuteur chez {{ senderName}}.',
        en: 'The credentials provided have expired. Please enter your most recent identifiers or contact your contact person at {{senderName}}.',
    },
    authentification403: {
        en: 'The login entered is incorrect and you cannot log in. Please check it or get in touch with your contact person at {{senderName}}.',
        fr: 'L’identifiant renseigné est incorrect et ne permet pas de vous identifier. Merci de vérifier votre saisie ou de contacter votre interlocuteur chez {{senderName}}.',
    },
    personalEmail: {
        en: 'Use a personal e-mail address that will allow you to access Digiposte at all times. Avoid work e-mail addresses that you will no longer have access to if you change employers.',
        fr: 'Utilisez un e-mail personnel qui vous permettra d’accéder à Digiposte tout le temps. Evitez les e-mails professionnels auxquels vous n’aurez plus accès si vous changez d’employeur.',
    },
    requiredField: {
        fr: 'Ce champ est obligatoire',
        en: 'This field is required',
    },
    otpFieldRequired: {
        fr: 'Ce champ est obligatoire (6 chiffres)',
        en: 'This field is required (6 digits)',
    },
    mailIncorrect: {
        fr: 'Format de l’e-mail incorrect. Il manque le point après le nom de domaine (exemple d’e-mail : email@domaine.fr).',
        en: 'Incorrect e-mail format. The dot after the domain name is missing (e-mail example: email@domaine.fr).',
    },
    noDigiposteSafeExist: {
        en: 'There is no Digiposte safe for this address. Please check the information you entered or select “No, I will create my Digiposte account” to create one.',
        fr: 'Il n’existe aucun coffre Digiposte à cette adresse. Merci de vérifier votre saisie ou de sélectionner “Non, je crée mon Digiposte” pour en créer un.',
    },
    otpManyUnsuccessful: {
        en: 'You have made too many unsuccessful attempts. Please try again later.',
        fr: 'Vous avez effectué trop de tentatives infructeuses. Merci de réessayez plus tard.',
    },
    otpInvalid: {
        fr: 'Code de vérification invalide. Merci de réessayer.',
        en: 'Invalid verification code. Please try again.',
    },
    toastrErrorResendCode: {
        fr: 'Nous n’avons pas pu vous envoyer un nouveau code de vérification, merci de réessayer plus tard.',
        en: 'We were unable to send you a new verification code, please try again later.',
    },
    toastrSuccessResendCode: {
        fr: 'Votre nouveau code de vérification vient d’être envoyé à l’adresse <strong>%s</strong>',
        en: 'We have just sent you a new verification code to %s',
    },
};
exports.default = MessagesEnumIE;
